module.exports = __webpack_public_path__ + "static/media/seasonalMenu.4233bdca.jpeg";